import {
  RESET,
  SET_IS_FETCHING_USERS,
  SET_IS_SAVING_USER,
  SET_SELECTED_USERS,
  SET_UNSELECTED_USERS,
  SET_USERS,
} from "./assignees.actionTypes";

const initialState = {
  isSavingUser: false,
  isFetchingUsers: false,
  users: [],
  selectedUsers: [],
  unSelectedUsers: [],
  activeUser: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_SAVING_USER: {
      return {
        ...state,
        isSavingUser: action.payload,
      };
    }

    case SET_IS_FETCHING_USERS: {
      return {
        ...state,
        isFetchingUsers: action.payload,
      };
    }

    case SET_USERS: {
      return {
        ...state,
        users: action.payload,
      };
    }

    case SET_SELECTED_USERS: {
      return {
        ...state,
        selectedUsers: action.payload,
      };
    }

    case SET_UNSELECTED_USERS: {
      return {
        ...state,
        unSelectedUsers: action.payload,
      };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
